// import React, { Component } from "react";
// import { useSelector } from "react-redux";

import { Component, useState } from "react"


class ModalBox extends Component {
  currentElement = null
  state = {
    myActive: false,
    id: Math.random(),
    footer: true,
    buttons: {
      success: 'Success',
      cancel: 'Cancel'
    }
  }
  // constructor (props) {
  //   super(props)
  //   // this.state.id = this.props.id ? this.props.id : this.id
  //   // console.log('construtot modal')
  // }
  componentDidUpdate (props, state) {
    console.log('chance', props.title)
      if (this.props.active)
        this.open()
      else
        this.close()
    // }
  }
  open = () => {
    this.currentElement.classList.add('is-active')
  }
  close = () => {
    // console.log('cerra modal')
    this.currentElement.classList.remove('is-active')
  }

  componentDidMount (props, state) {
    // console.log('gggggggggg', this.props, this.state)
    // console.log(this.props.footer)
    this.setState({
      id: this.props.id || this.state.id,
      footer: this.props.footer === undefined ? this.state.footer : this.props.footer,
      buttons: this.props.buttons ? {...this.props.buttons} : this.state.buttons
    })
    this.currentElement = document.getElementById(this.state.id)
    

    
  }
  render () {
    return (
      <div id={this.state.id} className="modal">
      <div className="modal-background" onClick={(evet) => {
            
            this.close()
            
          }}></div>
      <div className="modal-content">
        <div className="box">
          { this.props.children }
        </div>
      </div>
      <button className="modal-close is-large" aria-label="close" onClick={(evet) => {
            // this.setState({myActive: false})
            this.close()
            return this.props.onMClose ? this.props.onMClose() : false
          }}></button>
    </div>
    )
  }
      // setActive(props.active !== activec? props.active: false)
    // const page_data = useSelector((state) => {
    //     // console.log(state)
    //     return state.HeroBarReducer
    // });

        
    
}

export default ModalBox